/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
/* eslint-disable no-continue */

import * as marietta from '../..';
import * as marietta3d from '../../../marietta3d';
import {
  BUILDING_TYPE_MANSION, ITEM_MODE_NO, MIN_HEIGHT_EDITABLE_ITEM_PLAN_SIZE_MM, SITE_INPUT_MODE,
} from '../Constants';
import { GroupItem, MonicaObject, PinPicture, PinText, Room } from '../item';
import { GradeMasterCollection, MasterItemCollection } from '../collection';
import { ThreeView } from '../../view3d/webcad';
import { ObjectType } from '../../view3d/webcad/ObjectType';
import { ItemControllerLidarAddPin } from '../control';

export default class ItemManager {
  count: number = 0;

  lastCreatedItem: marietta.webcad.item.MonicaObject;

  _itemController: any;

  get itemController(): any {
    return this._itemController;
  }

  set itemController(value: any) {
    this._itemController = value;

    // レイヤーの初期化
    marietta.webcad.WebCADGlobal.layerGroup.enableItemMouseActions(true);

    // if (this._itemController == null) return;

    // itemControllerの種類をみて、アイテムの操作をONするかOFFするか判断する
    // if( this.isDrawMode ){
    //     marietta.webcad.WebCADGlobal.layerGroup.enableItemMouseActions( false );
    // }
  }

  // DRAWモード
  get isDrawMode(): boolean {
    // itemControllerの種類をみて、アイテムの操作をONするかOFFするか判断する
    switch (true) {
      case this._itemController == null:
      case this._itemController instanceof marietta.webcad.control.ItemController:
      case this._itemController instanceof marietta.webcad.control.ItemControllerFitting:
      case this._itemController instanceof marietta.webcad.control.ItemControllerRoom:
      case this._itemController instanceof marietta.webcad.control.ItemControllerRoomMobile:
      case this._itemController instanceof marietta.webcad.control.ItemControllerRoomMansion:
      case this._itemController instanceof marietta.webcad.control.ItemControllerSite:
      case this._itemController instanceof marietta.webcad.control.ItemControllerStair:
      case this._itemController instanceof marietta.webcad.control.ItemControllerRoof:
      case this._itemController instanceof marietta.webcad.control.ItemControllerWithGuide:
        return false;
      default:
        return true;
    }
  }

  /**
   * アイテム作成
   */
  createItem(info: marietta.webcad.collection.ItemInfoCollection, resolve = null, setEndItem:boolean = false): MonicaObject {
    const motoInfo: marietta.webcad.collection.ItemInfoCollection = info.clone();
    if (marietta.webcad.WebCADGlobal.doesItemSupportZPositioning(info.id)) info.is_wall_item = true;
    // カレントアイテムが作成中であれば削除
    this.deleteUnplacedItems();

    // カウントの追加
    this.count += 1;
    info.index = this.count;

    // 階の指定がなければ、現在の階を指定する
    if (info.floor === undefined) {
      info.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    }

    const tarLayer: marietta.webcad.layer.ItemLayer = info.id !== 'shitae' ? marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer(info.id, info.floor) : marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer(info.id, info.floor, true);
    let item;

    switch (info.id.substring(0, 3)) {
      case 'shi':
        item = new marietta.webcad.item.Shitae(info);
        break;
      case 'sit':
        item = new marietta.webcad.item.Site(info);
        break;
      case 'rom':
        // 部屋の色設定
        if (info.color === '' || info.color === undefined) {
          info = marietta.webcad.WebCADGlobal.setDefaultRoomSetting(info);
        }
        item = new marietta.webcad.item.Room(info);
        //デフォルト巾木高さ
        if( isNaN(info.habaki_height) ){
          const hasHabaki:boolean = marietta.webcad.WebCADGlobal.isRoomWithHabaki(info.id);
          const jsonData = marietta.webcad.WebCADGlobal.autoMain.Model.writeJSON();
          info.habaki_height = hasHabaki ? jsonData.height.habaki_height : 0;
        }
        break;
      case 'wal':
        item = new marietta.webcad.item.WallObject(info);
        break;
      case 'str':
        item = new marietta.webcad.item.Stair(info);
        break;
      case 'fit':
        item = new marietta.webcad.item.Fitting(info);
        if (setEndItem) this.setItemToGrade(item, marietta.webcad.WebCADGlobal.webcad2Dmanager.grade);
        break;
      case 'rof':
        item = new marietta.webcad.item.Roof(info);
        break;
      case 'col':
        item = new marietta.webcad.item.Column(info);
        item.setParentRoom();
        break;
      case 'bem':
        item = new marietta.webcad.item.Beam(info);
        item.setParentRoom();
        break;
      case 'txt':
        if (marietta.webcad.WebCADGlobal.isFreeTextItem(info.id)) {
          item = new marietta.webcad.item.FreeText(info);
        } else if (marietta.webcad.WebCADGlobal.isPinTextItem(info.id)) {
          item = new marietta.webcad.item.PinText(info);
        } else if (marietta.webcad.WebCADGlobal.isPinPictureItem(info.id)) {
          item = new marietta.webcad.item.PinPicture(info);
        } else if (marietta.webcad.WebCADGlobal.isPinPanoramaItem(info.id)) {
          item = new marietta.webcad.item.PinPanorama(info);
        }
        break;
      case 'mrk':
        item = new marietta.webcad.item.Mark(info);
        break;
      default:
        item = new marietta.webcad.item.MonicaObject(info);
        if (setEndItem) this.setItemToGrade(item, marietta.webcad.WebCADGlobal.webcad2Dmanager.grade);
        break;
    }
    tarLayer.addItem(item);

    // アイテムのサイズの初期化
    item.initMeasurement();

    // サイズ（と反転）の適用
    try {
      switch (info.id.substring(0, 3)) {
        case 'shi':
        case 'sit':
        case 'col':
        case 'bem':
        case 'txt':
        case 'mrk':
          break;
        case 'rom':
          if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects) marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
          break;
        case 'str':
          (item as marietta.webcad.item.Stair).changeSize(motoInfo.width, motoInfo.height);
          if (motoInfo.lr) item.reverse();
          break;
        case 'fit':
          if ((item as marietta.webcad.item.Fitting).itemInfo.use_mm) {
            (item as marietta.webcad.item.Fitting).changeSize(motoInfo.widthmm, 0, false);
          } else {
            (item as marietta.webcad.item.Fitting).changeSize(motoInfo.width, 0, true);
          }
          if (motoInfo.lr) item.reverse();
          // if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects) marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
          break;
        default:
          (item as marietta.webcad.item.MonicaObject).changeSizeForInit(motoInfo.widthmm, motoInfo.heightmm, false);
          if (motoInfo.lr) item.reverse();
          break;
      }
    } catch (error) {
      console.log(error);
    }

    // 最後に作成したアイテム
    this.lastCreatedItem = item;

    // 特定アイテムの震度入れ替え
    switch (item.itemInfo.id) {
      case 'rom01_01': // ポーチ
      case 'rom02_01': // 廊下
      case 'rom13_01': // 広縁
      case 'rom18_01': // バルコニー
        this.moveBottom(item);
        break;
      default:
        break;
    }

    // グレード設定してあって、end_itemが確定していない場合は、自動割り当て
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.grade != null && item.itemInfo.end_item_info == null) {
      if (-1 < item.itemInfo.id.indexOf('fit') || -1 < item.itemInfo.id.indexOf('equ') || -1 < item.itemInfo.id.indexOf('fur')) {
        const endItemInfo:MasterItemCollection = marietta.webcad.WebCADGlobal.webcad2Dmanager.grade.getItemInfoForSymbol(item.itemInfo.id);
        if (endItemInfo) {
          // 適用
          item.setToEndItem(endItemInfo);
        }
      }
      // 部屋の仕上材は end_item_info ではなく天井/床/壁の個別フィールドに入るため、上の条件では弾けない
      if (-1 < item.itemInfo.id.indexOf('rom') && !this.hasRoomFinish(item as Room)) {
        this.setRoomToGrade(item);
      }
    }

    item.itemInfo.updateArea();

    if (item instanceof marietta.webcad.item.Room && marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      this.currentItem = null;
    } else if (item instanceof marietta.webcad.item.PinText) {
      this.currentItem = null;
    } else if (marietta.webcad.WebCADGlobal.dimensionMenu.mode !== '3D') {
      this.currentItem = item;
    }

    if (resolve) resolve();

    // ライン測定を更新する
    if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects) {
      // stairItemを作成するとき、updateMeasureLine関数でdrawMeasureLineを使用しないでください。
      marietta.webcad.WebCADGlobal.updateMeasureLine(true, false);
    }
    return item;
  }

  /**
   * カレント
   */
  _currentItem: marietta.webcad.item.MonicaObject;

  set currentItem(_current) {
    if (_current && _current.itemInfo.id.indexOf('shi') > -1) _current = null;
    if( _current && (_current instanceof PinPicture) ){
      this.moveTop( _current )
    }

    if (marietta.webcad.WebCADGlobal.itemManager.itemController instanceof ItemControllerLidarAddPin) return;

    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE && _current instanceof marietta.webcad.item.Site) {
      (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1).layer_site as marietta.webcad.layer.SiteLayer).putLayerItemsInGroup();
      marietta.webcad.WebCADGlobal.itemControlPanel.setInfo();
      return;
    }

    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION
      && (this.currentItem instanceof marietta.webcad.item.Room || this.currentItem instanceof marietta.webcad.item.Column || this.currentItem instanceof marietta.webcad.item.Beam)) this.currentItem.highlight(false);



    // メニューボタン群の更新
    marietta.webcad.WebCADGlobal.itemMenuCategories.updateItemMenuButtons();

    this._currentItem = _current;

    // 寸法線を表示 room または wallObject item
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      marietta.webcad.WebCADGlobal.itemManager.showOrHideMeasureLine();
    }

    if (_current == null || (_current && !marietta.webcad.WebCADGlobal.isItemForQuotation(_current.itemInfo.id))) {
      if (marietta.webcad.WebCADGlobal._currentDialog && marietta.webcad.WebCADGlobal._currentDialog instanceof marietta.webcad.view.dialog.ItemChangeDialogStarts) {
        marietta.webcad.WebCADGlobal._currentDialog.closeEvent();
      }
    }

    if (document.getElementById('controller')) document.getElementById('controller').remove();
    if (document.getElementById('guide')) document.getElementById('guide').remove();
    if (document.getElementById('itemBoundGuide')) document.getElementById('itemBoundGuide').remove();
    if (document.getElementById('controller_snap_guide')) document.getElementById('controller_snap_guide').remove();

    // 屋根メニューの更新
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateRoofMenuToCurrent();

    // アイテムインフォパネル表示切替
    marietta.webcad.WebCADGlobal.itemControlPanel.setInfo();

    if (_current == null) {
      $('.itemListContainer').removeClass('selected');
      this.currentWall = null;
      return;
    }
    this.currentItemGroup = null;

    // 寸法線を表示 room または wallObject item
    marietta.webcad.WebCADGlobal.itemManager.showCurrentItemMeasureLine();

    // タブレットの場合は、お部屋・階段に移動ピッカー付にする
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;

    switch (_current.itemInfo.id.substring(0, 3)) {
      case 'sit':
        this.itemController = new marietta.webcad.control.ItemControllerSite(this._currentItem as marietta.webcad.item.Site);
        break;
      case 'bem':
      case 'col':
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          this.itemController = new marietta.webcad.control.ItemControllerRoomMansion(this._currentItem);
        } else if (ua.isMobile || ua.isTablet) {
          this.itemController = new marietta.webcad.control.ItemControllerRoomMobile(this._currentItem);
        } else {
          this.itemController = new marietta.webcad.control.ItemControllerRoom(this._currentItem);
        }
        marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList();
        break;
      case 'rom':
        const isSnap = marietta.webcad.WebCADGlobal.webcad2Dmanager.isSnap();
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          this.itemController = new marietta.webcad.control.ItemControllerRoomMansion(this._currentItem);
        } else if ((ua.isMobile || ua.isTablet) && isSnap) {
          this.itemController = new marietta.webcad.control.ItemControllerRoomMobile(this._currentItem);
        } else if(isSnap) {
          this.itemController = new marietta.webcad.control.ItemControllerRoom(this._currentItem);
        } else {
          this.itemController = new marietta.webcad.control.ItemControllerRoomDetached(this._currentItem);
        }
        marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList();
        break;
      case 'wal':
        this.itemController = new marietta.webcad.control.ItemControllerWallObject(this._currentItem as marietta.webcad.item.WallObject);
        (_current as marietta.webcad.item.WallObject).wallGuideList[0].showWallInput();
        break;
      // case 'col':
      //   this.itemController = new marietta.webcad.control.ItemControllerColumnWithGuide(this._currentItem as marietta.webcad.item.Column);
      //   break;
      case 'str':
        if (ua.isMobile || ua.isTablet) {
          this.itemController = new marietta.webcad.control.ItemControllerStairMobile(this._currentItem);
        } else {
          this.itemController = new marietta.webcad.control.ItemControllerStair(this._currentItem);
        }
        break;
      case 'fit':
        this.itemController = new marietta.webcad.control.ItemControllerFitting(this._currentItem);
        marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList();
        break;
      case 'rof':
        this.itemController = new marietta.webcad.control.ItemControllerRoof(this._currentItem as marietta.webcad.item.Roof);
        return;
      case 'fur':
      case 'equ':
        if (this._currentItem.itemInfo.is_wall_item) {
          this.itemController = new marietta.webcad.control.ItemControllerWallMountedItems(this._currentItem);
        } else {
          this.itemController = new marietta.webcad.control.ItemControllerWithGuide(this._currentItem);
        }
        marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList();
        return;
      case 'ext':
        if (marietta.webcad.WebCADGlobal.isAutoFacingItem(this._currentItem.itemInfo.id)) {
          this.itemController = new marietta.webcad.control.ItemControllerAutoFacingItems(this._currentItem);
        } else {
          this.itemController = new marietta.webcad.control.ItemController(this._currentItem);
        }
        marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList();
        break;
      case 'txt':
        if (this._currentItem.isFreeTextItem()) {
          this.itemController = new marietta.webcad.control.ItemControllerFreeText(this._currentItem as marietta.webcad.item.FreeText);
        } if (this._currentItem.isPinTextItem()) {
          this.itemController = new marietta.webcad.control.ItemControllerPinText(this._currentItem as marietta.webcad.item.PinText);
        } else if (this._currentItem.isPinPictureItem()) {
          this.itemController = new marietta.webcad.control.ItemControllerPinPicture(this._currentItem as marietta.webcad.item.PinPicture);
        } else if (this._currentItem.isPinPanoramaItem()) {
          this.itemController = new marietta.webcad.control.ItemControllerPinPicture(this._currentItem as marietta.webcad.item.PinPicture);
        }
        marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList();
        break;
      case 'mrk':
        this.itemController = new marietta.webcad.control.ItemControllerMark(this._currentItem);
        break;
      default:
        if (marietta.webcad.WebCADGlobal.isAutoFacingItem(this._currentItem.itemInfo.id)) {
          this.itemController = new marietta.webcad.control.ItemControllerAutoFacingItems(this._currentItem);
        } else {
          this.itemController = new marietta.webcad.control.ItemController(this._currentItem);
        }
        break;
    }
    ua = null;
  }

  get currentItem(): marietta.webcad.item.MonicaObject {
    return this._currentItem;
  }

  /**
   * 現在のACTIVEアイテムグループ
   * */
  _currentItemGroup: marietta.webcad.item.GroupItem;

  get currentItemGroup(): marietta.webcad.item.GroupItem {
    return this._currentItemGroup;
  }

  set currentItemGroup(value: marietta.webcad.item.GroupItem) {
    // 前のグループの削除
    if (this._currentItemGroup !== value && this._currentItemGroup instanceof marietta.webcad.item.GroupItem) {
      GroupItem.deleteMe();
    }

    this._currentItemGroup = value;
    marietta.webcad.WebCADGlobal.itemControlPanel.setInfo();
    if (this._currentItemGroup == null) return;
    // 初期化
    try {
      if (this.currentItem) this.currentItem = null;
    } catch (error) {
      console.log(error);
    }
  }

  /**
     * カレント壁
     */
  _currentWall: marietta.webcad.item.parts.Wall = null;

  set currentWall(_current: marietta.webcad.item.parts.Wall) {
    if (this._currentWall !== null) {
      this._currentWall.highlight(false);
    }
    this._currentWall = _current;
    if (_current === null) {
      return;
    }
    if (this.currentItem !== null || this.currentItemGroup !== null) {
      this.addWallToGroupObject(_current);
      this._currentWall = null;
      return;
    }
    _current.highlight(true);
    this.currentWallGroup = null;
    marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList();
  }

  get currentWall(): marietta.webcad.item.parts.Wall {
    return this._currentWall;
  }

  /**
   * 複数選択に、壁アイテムを追加します。
   * @param target
   * @param prevItem
   * @returns
   */
  addWallToGroupObject(target: marietta.webcad.item.parts.Wall, prevItem: marietta.webcad.item.parts.Wall = null): void {
    if (this.currentWallGroup != null) {
      this.currentWallGroup.selectItem(target);
    } else {
      if (prevItem === target && target != null) {
        return;
      }
      const itemList = [];
      if (prevItem)itemList.push(prevItem);
      itemList.push(target);

      // 複数選択
      this.addWalls(itemList);
    }
  }

  /**
   * 複数選択
   * @param itemList
   */
  addWalls(itemList: marietta.webcad.item.parts.Wall[]): void {
    this.currentWallGroup = new marietta.webcad.item.parts.GroupItemWall(itemList);
    const tarLayer: marietta.webcad.layer.GroupItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer('grp', marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) as marietta.webcad.layer.GroupItemLayer;
    (tarLayer as marietta.webcad.layer.GroupItemLayer).addParts(this.currentWallGroup);
  }

  /**
   * 現在のACTIVEアイテムグループ
   */
  _currentWallGroup: marietta.webcad.item.parts.GroupItemWall;

  get currentWallGroup(): marietta.webcad.item.parts.GroupItemWall { return this._currentWallGroup; }

  set currentWallGroup(value: marietta.webcad.item.parts.GroupItemWall) {
    // 前のグループの削除
    if (this._currentWallGroup !== value && this._currentWallGroup instanceof marietta.webcad.item.parts.GroupItemWall) {
      this._currentWallGroup.deleteMe();
    }

    this._currentWallGroup = value;
    if (this._currentWallGroup == null) return;
    // 初期化
    try {
      if (this.currentWall) this.currentWall = null;
    } catch (error) {
      console.log(error);
    }
    marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList();
  }

  /**
   * アイテムを前面へ
   */
  moveFront = (target: marietta.webcad.item.MonicaObject): void => {
    const tarLayer: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer(target.itemInfo.id, target.itemInfo.floor) as marietta.webcad.layer.ItemLayer;
    if (!target) return;
    const temp = target.viewObj;
    temp.parentNode.insertBefore(temp.nextSibling, temp);
    // 前面へ移動
    tarLayer.moveFront(target);
  };

  /**
   * アイテムを背面へ
   */
  moveBack = (target: marietta.webcad.item.MonicaObject) => {
    const tarLayer: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer(target.itemInfo.id, target.itemInfo.floor) as marietta.webcad.layer.ItemLayer;
    if (!target) return;
    const temp = target.viewObj;
    temp.parentNode.insertBefore(temp, temp.previousElementSibling);

    // 背面へ移動
    tarLayer.moveBack(target);
  };

  /**
   * アイテムを最前面へ
   */
  moveTop = (target: marietta.webcad.item.MonicaObject) => {
    const tarLayer: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer(target.itemInfo.id, target.itemInfo.floor) as marietta.webcad.layer.ItemLayer;
    if (!target) return;
    const temp = target.viewObj;
    const targetIndex = temp.parentNode.childNodes.length - 1;
    const targetElement = temp.parentNode.childNodes[targetIndex];
    temp.parentNode.insertBefore(temp, targetElement);
    temp.parentNode.insertBefore(targetElement, temp);
    // 前面へ移動
    tarLayer.moveTop(target);
  };

  /**
   * アイテムを最背面へ
   */
  moveBottom = (target: marietta.webcad.item.MonicaObject) => {
    const tarLayer: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer(target.itemInfo.id, target.itemInfo.floor) as marietta.webcad.layer.ItemLayer;
    if (!target) return;
    const temp = target.viewObj;
    const targetElement = temp.parentNode.childNodes[0];
    temp.parentNode.insertBefore(temp, targetElement);

    // 前面へ移動
    tarLayer.moveBottom(target);
  };

  /**
   * 選択中のアイテムをコピー
   */
  private _copiedItems;

  copyCurrentItemToMemory() {
    if (this.currentItem == null && this.currentItemGroup == null && this.currentWall == null && this.currentWallGroup == null) return;

    // 屋根はコピーできないよう防止
    if (this.currentItem instanceof marietta.webcad.item.Roof) {
      return;
    }
    if (this.currentItem instanceof marietta.webcad.item.Room && marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      return;
    }

    // 初期化
    this._copiedItems = [];

    // 現在のアイテム情報をメモリに保持しておく
    if (this.currentItem != null) {
      this._copiedItems.push(this.currentItem.itemInfo);
    } else {
      for (let i: number = 0; i < this.currentItemGroup.myItemList.length; i += 1) {
        if (!(this.currentItemGroup.myItemList[i] instanceof marietta.webcad.item.Site && (this.currentItemGroup.myItemList[i] as marietta.webcad.item.Site).inputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE)) {
          if (this.currentItemGroup.myItemList[i] instanceof marietta.webcad.item.Room && marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
            continue;
          }
          this._copiedItems.push(this.currentItemGroup.myItemList[i].itemInfo);
        }
      }
    }
  }

  /**
   * コピー済みのアイテムを配置
   */
  pasteCopiedItem() {
    if (this._copiedItems == null || this._copiedItems.length === 0) return;

    // 複数アイテムとして選択するか否か
    const createdItems = [];
    const itemList = [];
    let tarInfo;
    const len = this._copiedItems.length;
    let isPasteAllowed = true;
    for (let i = 0; i < len; i += 1) {
      // ItemInfoCollection オブジェクトのコピー
      tarInfo = (this._copiedItems[i] as marietta.webcad.collection.ItemInfoCollection).clone(true);
      tarInfo.guid = marietta.webcad.WebCADGlobal.getGuid();
      if (!marietta.webcad.WebCADGlobal.isItemAllowedOnCurrentFloor(tarInfo.id)) {
        isPasteAllowed = false;
        break;
      }

      // 現在の階数に貼り付ける
      tarInfo.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;

      // 配置する前に位置をずらす
      tarInfo.x += marietta.webcad.WebCADGlobal.PIX_IN_GRID / 2; // 半グリッド分
      tarInfo.y += marietta.webcad.WebCADGlobal.PIX_IN_GRID / 2;

      itemList.push(tarInfo);
    }
    if (itemList.length >= 1 && isPasteAllowed) {
      for (let i = 0; i < itemList.length; i += 1) {
        const createdItem: MonicaObject = this.createItem(itemList[i]);
        // コピー元の位置・階で天井に連動していた UB は、貼った所の天井高さにする
        marietta.webcad.util.UnitBathUtil.fitToCeilingOnCopy(createdItem, this._copiedItems[i]);
        createdItems.push(createdItem);
      }
    } else {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_PASTE_ITEM'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
    }
    // アイテムコントローラー更新
    if (createdItems.length > 1) {
      this.addItems(createdItems);
    } else {
      this.currentItem = createdItems[0] as marietta.webcad.item.MonicaObject;
    }
    marietta.webcad.WebCADGlobal.quotationItemList.createData();

    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  }

  /**
   * 未配置アイテムの削除
   */
  deleteUnplacedItems() {
    // カレントアイテム解放
    if (this.currentItem !== undefined && this.currentItem != null) {
      if (this.currentItem.isFollowingMouse) {
        this.currentItem.stopFollowMouse();
        this.currentItem.deleteMe();
      }
    }

    // カレントグループ解放
    if (this.currentItemGroup !== undefined && this.currentItemGroup != null) {
      if (this.currentItemGroup.isFollowingMouse) {
        this.currentItemGroup.stopFollowMouse();
        this.currentItemGroup.myItemList.forEach((item) => {
          if (item !== undefined && item != null) {
            item.deleteMe();
          }
        });
        GroupItem.deleteMe();
      }
    }

    // //各階の各レイヤーの未配置アイテムの削除
    // let itemLayer:marietta.webcad.layer.ItemLayer;
    // let key:string;
    // for( let i:number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i+=1 ){
    //     for( let k:number = 1; k <= marietta.webcad.WebCADGlobal.MAX_MODE; k+=1 ){
    //         key = marietta.webcad.WebCADGlobal.getModeKeyFromNo( k );
    //         itemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer( key, i );
    //         if( itemLayer == null || itemLayer == undefined ) continue;
    //         //未配置のものをすべて削除
    //         itemLayer.deleteUnplacedItems();
    //     }
    // }

    // コントローラーの削除
    if (this.itemController != null) {
      try {
        // drawImageの削除
        if (typeof this.itemController.interrupt === 'function') this.itemController.interrupt();
      } catch (error) {
        console.log(error);
      }
      try {
        if (this.itemController instanceof marietta.webcad.control.ItemControllerRoomWallEdit) this.itemController.deleteMe();
      } catch (error) {
        console.log(error);
      }
    }
  }

  /**
   * アイテムリスト
   */
  getItemListByMode = (typeNo: number): MonicaObject[] => {
    const tarLayer1: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, typeNo);
    const tarLayer2: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(2, typeNo);
    const tarLayer3: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(3, typeNo);
    const itemList1: MonicaObject[] = tarLayer1.getAllChildren();
    const itemList2: MonicaObject[] = tarLayer2.getAllChildren();
    const itemList3: MonicaObject[] = tarLayer3.getAllChildren();

    return itemList1.concat(itemList2, itemList3);
  };

  /**
   * アイテムリスト
   */
  getItemListByModeAndFloor = (typeNo: number, floor:number): MonicaObject[] => {
    const tarLayer1: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, typeNo);
    const tarLayer2: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(2, typeNo);
    const tarLayer3: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(3, typeNo);

    switch ( floor ){
      case 3: return tarLayer3.getAllChildren();
      case 2: return tarLayer2.getAllChildren();
      case 1: return tarLayer1.getAllChildren();
    }
    return [];
  };

  /**
   * 部屋の囲み入力を開始する
   */
  startRoomKakomiInput() {
    // //カレントを外す
    // if( this.currentItem != undefined ) this.currentItem = null;
    this.itemController = new marietta.webcad.control.ItemControllerRoomPointInput();
    // eslint-disable-next-line no-multi-assign
    this.itemController.callbackOnComplete = this.itemController.callbackOnInterrupt = this.continueRoomPointInput;
  }

  /**
   * 壁
   */
  startWalliInput() {
    this.itemController = new marietta.webcad.control.ItemControllerRoomPointInput();
    // eslint-disable-next-line no-multi-assign
    this.itemController.callbackOnComplete = this.itemController.callbackOnInterrupt = this.continueRoomPointInput;
  }

  /**
   * 部屋のドラッグ入力を開始する
   */
  startRoomDragInput() {
    // //カレントを外す
    // if( this.currentItem != undefined ) this.currentItem = null;
    this.itemController = marietta.webcad.control.ItemControllerRoomDragInput.getInstance();
    // this.itemController = new marietta.webcad.control.ItemControllerRoomDragInput();
  }

  /**
   * 建具のドラッグ入力を開始する
   */
  startFittingDragInput() {
    // カレントを外す
    if (!this.currentItem) this.currentItem = null;
    this.itemController = marietta.webcad.control.ItemControllerFittingDragInput.getInstance();
    // this.itemController = new marietta.webcad.control.ItemControllerFittingDragInput();
  }

  /**
   * 敷地入力を開始する
   */
  startSiteInput() {
    // カレントを外す
    if (!this.currentItem) this.currentItem = null;
    this.itemController = new marietta.webcad.control.ItemControllerSitePointInput();
    this.itemController.callbackOnComplete = this.continueSitePointInput;
    this.itemController.callbackOnInterrupt = this.continueSitePointInput;
  }

  /**
   * 屋根入力を開始する
   */
  startRoofInput() {
    // カレントを外す
    if (!this.currentItem) this.currentItem = null;
    this.itemController = new marietta.webcad.control.ItemControllerRoofPointInput();
  }

  startTouchInput(callback: Function) {
    // カレントを外す
    if (!this.currentItem) this.currentItem = null;
    this.itemController = new marietta.webcad.control.ItemControllerMobileTouchInput();
    this.itemController.callbackOnComplete = callback;
  }

  /**
   * 部屋のペン入力を開始する
   */
  startRoomSketch() {
    this.itemController = new marietta.webcad.control.ItemControllerRoomSketch();
    // this.itemController.callbackOnComplete = this.continueRoomSketch;
    // this.itemController.callbackOnInterrupt = this.continueRoomSketch;
  }

  /**
   *無料の文字作成を開始します
  */
  startFreeCharacterInput(isPin: boolean) {
    // カレントを外す
    if (this.currentItemGroup !== undefined) this.currentItemGroup = null;
    this.itemController = new marietta.webcad.control.ItemControllerFreeCharacterInput(isPin);
  }

  /**
   * パノラマピンの作成
   */
  startPanoramaPinInput() {
    this.itemController = new marietta.webcad.control.ItemControllerPanoramaPinInput();
  }

  /**
  //  * 部屋ペン入力モード継続
  //  */
  // continueRoomSketch=() => {
  //   marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode;
  // }

  hasMeasureLine: boolean = false;

  // TODO: 引数の型設定する（元はXML）
  /**
   * 寸法線の作成
   */
  drawMeasureLine = (updateDimension: boolean = false) => {
    // 既に寸法線があれば消す、なければ生成
    marietta.webcad.WebCADGlobal.itemManager.hasMeasureLine = false;
    let tarLayer: marietta.webcad.layer.FloorLayer;
    for (let i = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
      tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i);
      if ((tarLayer.layer_measure as marietta.webcad.layer.MeasureLayer).hasMeasureLine() || marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement) {
        this.hasMeasureLine = true;
        for (let j = 1; j <= marietta.webcad.WebCADGlobal.MAX_FLOORS; j += 1) {
          // 寸法線をクリア
          (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(j).layer_measure as marietta.webcad.layer.MeasureLayer).initMe();
        }
        if (updateDimension || marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement) {
          // ヘッダーメニューの表示切替(非表示)
          marietta.webcad.WebCADGlobal.webcad2Dmanager.updateBtnSunpousen(false);

          // 寸法線の情報を取得して描画
          marietta.webcad.WebCADGlobal.cadAPIManager.getSunpousen(marietta.webcad.WebCADGlobal.itemManager.onDrawMeasureLine);
          return;
        }
        // ヘッダーメニューの表示切替(表示)
        marietta.webcad.WebCADGlobal.webcad2Dmanager.updateBtnSunpousen(true);
        return;
      }
    }

    if (!updateDimension) {
      // ヘッダーメニューの表示切替(非表示)
      marietta.webcad.WebCADGlobal.webcad2Dmanager.updateBtnSunpousen(true);

      // 寸法線の情報を取得して描画
      marietta.webcad.WebCADGlobal.cadAPIManager.getSunpousen(marietta.webcad.WebCADGlobal.itemManager.onDrawMeasureLine);
    }
  };

  /**
   * 寸法線の作成が完了したら、描画する
   */
  onDrawMeasureLine = () => {
    for (let i = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
      (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i).layer_measure as marietta.webcad.layer.MeasureLayer).drawMeasure(marietta.webcad.WebCADGlobal.webcad2Dmanager.measureLineData[i - 1]);
    }
  };

  /**
     * 寸法線の表示・非表示
     */
  showOrHideMeasureLine() {
    const itemList: marietta.webcad.item.Room[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.Room[];
    for (let i: number = 0; i < itemList.length; i += 1) {
      itemList[i].showHideWallGuide(false);
    }
    const wallItemList: marietta.webcad.item.WallObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_WALL_NO) as marietta.webcad.item.WallObject[];
    for (let i: number = 0; i < wallItemList.length; i += 1) {
      wallItemList[i].showHideWallGuide(false);
    }
  }

  /**
   * 選択した currentItem ディメンションを表示
   */
  showCurrentItemMeasureLine() {
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      const itemList = [];
      if (this.currentItemGroup) {
        for (let i: number = 0; i < this.currentItemGroup.myItemList.length; i += 1) {
          if (this.currentItemGroup.myItemList[i] instanceof marietta.webcad.item.Room || this.currentItemGroup.myItemList[i] instanceof marietta.webcad.item.WallObject) {
            itemList.push(this.currentItemGroup.myItemList[i]);
          }
        }
      } else if (this.currentItem != null) {
        if (this.currentItem instanceof marietta.webcad.item.Room || this.currentItem instanceof marietta.webcad.item.WallObject) {
          itemList.push(this.currentItem);
        }
      }
      for (let i: number = 0; i < itemList.length; i += 1) {
        itemList[i].showHideWallGuide(true);
      }
    }
  }

  /**
   * ピンの表示・非表示
   */
  showOrHidePin() {
    if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
      if (ThreeView.get().ItemDragManager && marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible === false) { // カメラピンの選択をオフ、吹き出しをオフ
        if (ThreeView.get().ItemDragManager.selectObj != null && ObjectType.isCameraPin(ThreeView.get().ItemDragManager.selectObj)) ThreeView.get().ItemDragManager.resetController();
        ThreeView.get().cameraPinManager.remove();
      }
      ThreeView.get().wcScene.me.traverse((object) => {
        if (object.userData.modelInfo && object.userData.modelInfo.typeExtras === marietta.view3d.webcad.webcadDefines.ExtrasType.CAMERA_PIN) {
          object.visible = marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible;
        }
        if (object.userData.modelInfo && object.userData.modelInfo.typeExtras === marietta.view3d.webcad.webcadDefines.ExtrasType.PIN) {
          object.visible = marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible;
        }
      });
    } else {
      const itemList: marietta.webcad.item.PinText[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FREETEXT_NO) as marietta.webcad.item.PinText[];
      itemList.forEach((item) => {
        item.visible = marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible;
      });
    }
  }

  /**
   * 一括ロック
   */
  lockAll(value: boolean) {
    const allItems = marietta.webcad.WebCADGlobal.layerGroup.getAllItems();

    // 全てのアイテムのロック・ロック解除
    // var initFittingList:boolean = false;
    for (let i = 0, len = allItems.length; i < len; i += 1) {
      if (allItems[i]) {
        // if( allItems[i].hasOwnProperty("manager") == false )continue;
        this.itemLock(allItems[i], value);
      }
    }
    if (!this.currentItem) this.currentItem = null;

    // パネル更新
    marietta.webcad.WebCADGlobal.itemControlPanel.panelUpdate();
  }

  /**
   * 部屋の編集
   * @param mode 壁削除：removeWall頂点追加：addPoint
   * */
  editRooms(mode: string) {
    // コントローラーをつける
    // 初期化
    if (!this.currentItem) this.currentItem = null;
    // 作成
    switch (mode) {
      case 'removeWall':
      case 'addWall':
      case 'addPoint':
      case 'calibrationWall':
        this.itemController = new marietta.webcad.control.ItemControllerRoomWallEdit(mode);
        break;
      default:
        break;
    }
  }

  /**
   * コントローラーのサイズの更新
   */
  public refreshControllerSize(): void {
    if (!this.itemController) {
      this.itemController.updatePickers();
    } else {
      console.log('no controller');
    }
  }

  /**
   * 範囲指定開始
   * @param preserveSelection true の場合、開始時点の選択状態（現在選択中のアイテム）をクリアせずに保持する
   */
  startDragGroupSelect(preserveSelection: boolean = false): void {
    this.itemController = marietta.webcad.control.ItemControllerDragGroupSelect.getInstance(preserveSelection);
  }

  /**
   * 囲み入力モードの終了
   */
  pointInputInterrupt() {
    if (!(this.itemController instanceof marietta.webcad.control.ItemControllerBasePointInput)) return;
    (this.itemController as marietta.webcad.control.ItemControllerBasePointInput).interrupt();
  }

  /**
   * 複数選択に、アイテムを追加します。
   * */
  addItemToGroupObject(target: marietta.webcad.item.MonicaObject, prevItem: marietta.webcad.item.MonicaObject = null): void {
    if (this.currentItemGroup != null && this.currentItemGroup) {
      this.currentItemGroup.selectItem(target);
    } else {
      if (prevItem === target && target != null) {
        return;
      }
      const itemList = [];
      // null をグループに含めると GroupItem の描画作成で落ちるため、直前アイテムがある場合のみ追加する
      if (prevItem) itemList.push(prevItem);
      itemList.push(target);
      this.currentItemGroup = new marietta.webcad.item.GroupItem(itemList);

      const tarLayer: marietta.webcad.layer.GroupItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer('grp', marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) as marietta.webcad.layer.GroupItemLayer;
      (tarLayer as marietta.webcad.layer.GroupItemLayer).addParts(this.currentItemGroup);
    }
    // 寸法線を表示 room または wallObject item
    marietta.webcad.WebCADGlobal.itemManager.showCurrentItemMeasureLine();
  }

  /**
   * 複数選択
   * */
  addItems(itemList): void {
    this.currentItemGroup = null;
    this.currentItemGroup = new marietta.webcad.item.GroupItem(itemList);

    const tarLayer: marietta.webcad.layer.GroupItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer('grp', marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) as marietta.webcad.layer.GroupItemLayer;
    (tarLayer as marietta.webcad.layer.GroupItemLayer).addParts(this.currentItemGroup);
    // 寸法線を表示 room または wallObject item
    marietta.webcad.WebCADGlobal.itemManager.showCurrentItemMeasureLine();
  }

  /**
   * アイテムをロック/アンロック
   * @param tarItem - 対象のアイテム
   * @param value - ロック/アンロック
   */
  itemLock(tarItem: marietta.webcad.item.MonicaObject, value: boolean) {
    // アイテムインフォ更新
    tarItem.itemInfo.lock = value;
    this.currentItem = tarItem;
    // ロック状態のビジュアルを更新
    if (value) {
      tarItem.changeLockView(true);
      switch (tarItem.itemInfo.id.substring(0, 3)) {
        case 'shi':
        case 'sit':
          break;
        default:
          if (!this.itemController) {
            this.itemController.hideToolTips();
          }
          break;
      }
    } else {
      tarItem.changeLockView(false);
      switch (tarItem.itemInfo.id.substring(0, 3)) {
        case 'shi':
        case 'sit':
          break;
        default:
          if (!this.itemController) {
            this.itemController.showToolTips();
          }
          break;
      }
    }
  }

  /**
   * 部屋結合用の選択部屋リストを取得
   * */
  getSelectedRoomsForJoin(): marietta.webcad.item.Room[] {
    const roomList = [];
    if (this.currentItemGroup) {
      for (let i: number = 0; i < this.currentItemGroup.myItemList.length; i += 1) {
        if (this.currentItemGroup.myItemList[i] instanceof marietta.webcad.item.Room) {
          roomList.push(this.currentItemGroup.myItemList[i]);
        }
      }
    }
    return roomList;
  }

  /**
   * 部屋頂点入力モード継続
   */
  continueRoomPointInput = (): void => {
    // marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode;
  };

  /**
   * 敷地頂点入力モード継続
   */
  continueSitePointInput = (): void => {
    // アクションモードを定義し直して、再開をする
    // eslint-disable-next-line no-self-assign
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode;
  };

  /**
   * 建具自動生成ボタンが押された
   */
  onGenerateFittingButtonClicked = (): void => {
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ConfirmGenerateFittingsDialog2);
  };

  /**
   * 住宅設備 自動生成ボタンが押された
   */
  onGenerateEquipmentButtonClicked = (): void => {
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ConfirmGenerateEquipmentDialog);
  };

  /**
   * 廊下自動生成ボタンが押された
   */
  onGenerateHallwayButtonClicked = (): void => {
    // 玄関がなければアラートを出す
    const floorLayer: marietta.webcad.layer.FloorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1) as marietta.webcad.layer.FloorLayer;
    const tarLayer: marietta.webcad.layer.ItemLayer = floorLayer.layer_room as marietta.webcad.layer.ItemLayer;
    if (tarLayer.hasItemByCode('rom03_01') === false) {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_NEED_ENTRANCE_AUTO'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
      return;
    }

    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ConfirmGenerateHallwayDialog);
    // marietta.webcad.WebCADGlobal.cadAPIManager.generateHallways();
  };

  /**
   * 梁の自動生成ボタンが押された
   */
  public onGenerateBeamButtonClicked() {
    // 梁が存在していれば、ダイアログを表示する
    if (this.hasBeam()) {
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.AutoBeamCheckDialog);
      return;
    }

    marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
    // 梁自動生成
    const autoBeam = new marietta.webcad.AutoGenerator.AutoBeam();
    autoBeam.createBeamOuterWall();

    // 梁が存在していたらウィザード開始
    if (this.hasBeam()) {
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.WizardBeamSizeSettingDialog);
    }
  }

  /**
   * 梁が存在するか
   * @returns
   */
  public hasBeam() {
    const currentFloor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    const floorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(currentFloor) as marietta.webcad.layer.FloorLayer;
    const tarLayer = floorLayer.layer_beam as marietta.webcad.layer.ItemLayer;

    return tarLayer.hasItemByCode('bem01_01');
  }

  /**
   * モジュールピッチ変更の影響をうけるアイテム（住宅設備・家具・エクステリア）のサイズ再計算
   * ※実寸(mm)自体を新旧ピッチの比率で拡大縮小する（例: 900→1800(2倍)ならアイテムの実寸も2倍）。
   *   `changeSize` は force=true で呼び、確定済み（エンドアイテム設定済み）のアイテムにも適用する。
   * @param pitchRatio 新ピッチ / 旧ピッチ の比率
   */
  public resizeModuleEffectItems = (pitchRatio: number): void => {
    if (!Number.isFinite(pitchRatio) || pitchRatio <= 0 || pitchRatio === 1) return;

    let itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_EQUIPMENT_NO);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FURNITURE_NO));
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_EXTERIOR_NO));

    for (let i: number = 0; i < itemList.length; i += 1) {
      const tarItem: marietta.webcad.item.MonicaObject = itemList[i];
      let newWidthMm: number = Math.round(tarItem.itemInfo.widthmm * pitchRatio);
      let newHeightMm: number = Math.round(tarItem.itemInfo.heightmm * pitchRatio);
      // 住設・家具は 1mm まで小さくできるため、縮めて 0mm にならないよう入力の下限で止める
      if (tarItem.isHeightEditableItem()) {
        newWidthMm = Math.max(MIN_HEIGHT_EDITABLE_ITEM_PLAN_SIZE_MM, newWidthMm);
        newHeightMm = Math.max(MIN_HEIGHT_EDITABLE_ITEM_PLAN_SIZE_MM, newHeightMm);
      }
      tarItem.changeSize(newWidthMm, newHeightMm, false, true);
    }
  };

  /**
   * お部屋のサイズ表記の更新
   */
  updateRoomSizeTexts = (): void => {
    let tarItem: marietta.webcad.item.Room;
    let itemList: marietta.webcad.item.Room[] = <marietta.webcad.item.Room[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO);
    itemList = itemList.concat(<marietta.webcad.item.Room[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO));
    itemList = itemList.concat(<marietta.webcad.item.Room[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO));

    for (let i: number = 0; i < itemList.length; i += 1) {
      tarItem = itemList[i] as marietta.webcad.item.Room;
      tarItem.overlayText.update();
    }
  };

  /**
   * お部屋の内側寸法（壁ガイド）の表示値を現在のモジュールピッチで再計算する。
   * 生成時のピッチで値が固定されるため、ピッチ変更時に明示的に呼ぶ必要がある。
   */
  public updateRoomWallGuides = (): void => {
    let tarItem: marietta.webcad.item.Room;
    let itemList: marietta.webcad.item.Room[] = <marietta.webcad.item.Room[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO);
    itemList = itemList.concat(<marietta.webcad.item.Room[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO));
    itemList = itemList.concat(<marietta.webcad.item.Room[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO));

    for (let i: number = 0; i < itemList.length; i += 1) {
      tarItem = itemList[i] as marietta.webcad.item.Room;
      tarItem.updateWallGuide();
    }
  };

  /**
   * 部屋名の一括表示／非表示機能
   */
  showAllRoomNames = (value: boolean) => {
    let tarItem: marietta.webcad.item.Room;
    let itemList: marietta.webcad.item.Room[] = <marietta.webcad.item.Room[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO);
    itemList = itemList.concat(<marietta.webcad.item.Room[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO));
    itemList = itemList.concat(<marietta.webcad.item.Room[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO));

    for (let i: number = 0; i < itemList.length; i += 1) {
      tarItem = itemList[i] as marietta.webcad.item.Room;
      tarItem.overlayText.visible = value;
    }
  };

  /**
   * アイテムを動かし終わったときの処理（移動の各経路から、カレントを入れ直す前・履歴に載せる前に呼ぶ）
   * 別の部屋へ動いた UB を、H 欄に出す前に天井高さに合わせる（履歴を積まない移動もここで確定する）
   */
  public onItemsMoved(): void {
    marietta.webcad.WebCADGlobal.webcad2Dmanager.commitWithoutHistory();
  }

  /**
   * キーボード操作によってアイテムを移動する
   */
  moveItemFromkeyboard(x: number = 0, y: number = 0) {
    let snapUnit: number;
    let destX: number;
    let destY: number;
    if (this.currentItem) {
      // カレントがロック状態であれば無視する
      if (!this.currentItem.isCapableOfMove()) return;

      // カレントアイテムの場合
      let childX: number;
      let childY: number;
      switch (this.currentItem.constructor.name) {
        case 'Room':
        case 'Stair':
        case 'Fitting':
          snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
          destX = x * snapUnit + this.currentItem.itemInfo.x;
          destY = y * snapUnit + this.currentItem.itemInfo.y;
          if (this.currentItem instanceof marietta.webcad.item.Room) {
            childX = (this.currentItem as marietta.webcad.item.Room).overlayText.x + x * snapUnit;
            childY = (this.currentItem as marietta.webcad.item.Room).overlayText.y + y * snapUnit;
            (this.currentItem as marietta.webcad.item.Room).overlayText.move(childX, childY);
          }

          break;
        default:
          destX = x + this.currentItem.itemInfo.x;
          destY = y + this.currentItem.itemInfo.y;
      }
      this.currentItem.move(destX, destY);
      // カレントを入れ直す前に呼んで、移動後の値を H 欄に出す
      this.onItemsMoved();
      this.currentItem = marietta.webcad.WebCADGlobal.itemManager.currentItem;
    } else if (this.currentItemGroup) {
      // カレントがロック状態であれば無視する
      if (!this.currentItemGroup.isCapableOfMove()) return;

      // カレントアイテムグループの場合
      if (this.currentItemGroup.hasGridSnapItem) {
        snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
        destX = x * snapUnit;
        destY = y * snapUnit;
        this.currentItemGroup.spt.x = x * snapUnit;
        this.currentItemGroup.spt.y = y * snapUnit;
      } else {
        destX = this.currentItemGroup.spt.x + x;
        destY = this.currentItemGroup.spt.y + y;
      }
      this.currentItemGroup.move(destX, destY);
      this.onItemsMoved();
    }

    // 保管
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

    // ライン測定を更新する
    marietta.webcad.WebCADGlobal.updateMeasureLine();
  }

  /**
   * 屋根の全取得
   */
  getAllRoofs() {
    // 屋根オブジェクトが1個もない場合は、行わない
    const itemList: marietta.webcad.item.Roof[] = <marietta.webcad.item.Roof[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOF_NO);
    if (itemList.length < 1) {
      return;
    }

    // 屋根形状作成
    marietta.webcad.WebCADGlobal.cadAPIManager.getRoof(this.onGetAllDrawRoofDesign, this.onGetAllDrawRoofDesignError, true);
  }

  /**
   * 屋根の全取得完了
   */
  onGetAllDrawRoofDesign = (list) => {
    // 屋根オブジェクトが1個もない場合は、行わない
    const itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOF_NO);
    if (itemList.length < 1) {
      return;
    }
    // 階数ごとのリストに分ける
    let tarRoof: marietta.webcad.item.Roof;
    let tarFloor: number;
    let datList: marietta3d.AutoGen.object.AutoObjRoof[][];
    for (let i = 0; i < itemList.length; i += 1) {
      datList = [];
      tarRoof = itemList[i] as marietta.webcad.item.Roof;
      tarFloor = tarRoof.itemInfo.floor;
      datList.push(list[tarFloor - 1]);
      tarRoof.onDrawRoofDesign(datList);
    }
    marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
  };

  /**
   * 屋根の全取得失敗
   */
  onGetAllDrawRoofDesignError = (): void => {
    // 屋根を全て削除する
    marietta.webcad.WebCADGlobal.layerGroup.floor1.layer_roof.removeAllChildren();
    marietta.webcad.WebCADGlobal.layerGroup.floor2.layer_roof.removeAllChildren();
    marietta.webcad.WebCADGlobal.layerGroup.floor3.layer_roof.removeAllChildren();
  };

  /**
   * 建具をcreateIndexを頼りに探す
   */
  // getFittingByCreateIndex = (createIndex: number): marietta.webcad.item.Fitting => {
  //   // ターゲットの建具を予めリンクしておく
  //   let itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTINGDOWN1_NO);
  //   itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTING_NO));
  //   for (let i: number = 0; i < itemList.length; i += 1) {
  //     if ((itemList[i] as marietta.webcad.item.Fitting).itemInfo.createindex === createIndex) {
  //       return itemList[i] as marietta.webcad.item.Fitting;
  //     }
  //   }
  //   return null;
  // };

  /**
   * MeasureLineを非表示
   */
  hideMeasureLine = (): void => {
    for (let i: number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
      const tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i);
      (tarLayer.layer_measure as marietta.webcad.layer.MeasureLayer).hide();
    }
  };

  /**
   * MeasureLineを表示
   */
  showMeasureLine = (): void => {
    for (let i: number = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
      const tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i);
      if (i === marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) {
        (tarLayer.layer_measure as marietta.webcad.layer.MeasureLayer).show();
      } else {
        (tarLayer.layer_measure as marietta.webcad.layer.MeasureLayer).hide();
      }
    }
  };

  /**
   * アイテムを選択できるかどうかを確認する機能。 現在開いているメニューによって異なります
   * @param item
   */
  isCapableToSelect = (item: marietta.webcad.item.MonicaObject): boolean => {
    if (!marietta.webcad.WebCADGlobal.itemMenu.currentMenuID) return true;
    let status = false;
    switch (marietta.webcad.WebCADGlobal.itemMenu.currentMenuID) {
      case '#itemMenu_site':
        if (item.itemInfo.id.indexOf('sit') > -1) status = true;
        break;
      case '#itemMenu_room':
        if (item.itemInfo.id.indexOf('rom') > -1) status = true;
        break;
      case '#itemMenu_stair':
        if (item.itemInfo.id.indexOf('str') > -1) status = true;
        break;
      case '#itemMenu_fitting':
        if (item.itemInfo.id.indexOf('fit') > -1) status = true;
        break;
      case '#itemMenu_equipment':
        if (item.itemInfo.id.indexOf('equ') > -1) status = true;
        break;
      case '#itemMenu_furniture':
        if (item.itemInfo.id.indexOf('fur') > -1) status = true;
        break;
      case '#itemMenu_exterior':
        if (item.itemInfo.id.indexOf('ext') > -1) status = true;
        break;
      case '#itemMenu_roof':
        if (item.itemInfo.id.indexOf('rof') > -1) status = true;
        break;
      case '#itemMenu_draw':
        if (item.itemInfo.id.indexOf('txt') > -1) status = true;
        break;
      default:
        break;
    }
    return status;
  };

  /**
   * 選択中のカレントを非選択状態にする
   */
  unselectAllCurrents(): void {
    this.currentItem = null;
    this.currentItemGroup = null;
    this.currentWall = null;
    this.currentWallGroup = null;

    console.log('unselectAllCurrents');
  }

  /**
   *アイテムの編集
   * @param guid
   * @param x
   * @param y
   * @param z
   * @param rotation
   * @param _widthmm
   * @param _heightmm
   * @param depth
   */
  update2Ditem = (guid:string, x:number = null, y:number = null, z:number = null, rotation:number = null, _widthmm:number = null, _heightmm:number = null, depth:number = null) => {
    const item:MonicaObject = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(guid);
    if (item) {
      if (x !== null) item.itemInfo.x = marietta.webcad.util.WebCADUtil.convertMMToPix(x);
      if (y !== null) item.itemInfo.y = marietta.webcad.util.WebCADUtil.convertMMToPix(y);
      if (z !== null) item.itemInfo.z = Math.round(z * 100) / 100;

      if (depth !== null) item.itemInfo.depth = depth;
      if (_widthmm !== null) {
        item.itemInfo.widthmm = _widthmm;
        item.itemInfo.width = MonicaObject.floorDrawSizePix(marietta.webcad.util.WebCADUtil.convertMMToPix(_widthmm));
      }
      if (_heightmm !== null) {
        item.itemInfo.heightmm = _heightmm;
        item.itemInfo.height = MonicaObject.floorDrawSizePix(marietta.webcad.util.WebCADUtil.convertMMToPix(_heightmm));
      }
      if (rotation) item.itemInfo.rotation = rotation;
      if (marietta.webcad.WebCADGlobal.isPinTextItem(item.itemInfo.id)) {
        const textSize = marietta.webcad.util.TextUtil.getTextSizeWh(item.itemInfo.text, marietta.webcad.WebCADGlobal.freeTextFontFamily, marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size);
        item.itemInfo.width = textSize.width;
        item.itemInfo.height = textSize.height;
        item.itemInfo.rotation = 0;
        item.reCreateImage();
      } else {
        item.updateTransforms();
      }
      const heightData = this.getFloorAndCeilingHeight();
      const isCelingItem = marietta.webcad.WebCADGlobal.ceilingItemCodeList.includes(item.itemInfo.id);
      const isWallItem = marietta.webcad.WebCADGlobal.doesItemSupportZPositioning(item.itemInfo.id);
      const isHeightEditableItem = marietta.webcad.WebCADGlobal.isHeightEditableItem(item.itemInfo.id);
      const fl = item.itemInfo.floor === 1 ? heightData.fl1 : (item.itemInfo.floor === 2 ? heightData.fl2 : heightData.fl3);
      const ceiling = item.itemInfo.floor === 1 ? heightData.cl1 : (item.itemInfo.floor === 2 ? heightData.cl2 : heightData.cl3);
      if (isCelingItem) item.itemInfo.is_ceiling_item = true;
      // z を渡されたときだけ変換する（未指定で再変換すると fl が二重に引かれるため）
      if (z !== null) {
        switch (true) {
          case (isCelingItem && isWallItem):
            item.itemInfo.z = ceiling - item.itemInfo.z;
            break;
          case (isCelingItem && !isWallItem):
            item.itemInfo.z = 0;
            break;
          case (!isCelingItem && isWallItem):
            item.itemInfo.z -= fl;
            break;
          case (isHeightEditableItem):
            item.itemInfo.z = this.toFloorItemZ(item.itemInfo.z, fl);
            break;
          default:
            if (!marietta.webcad.WebCADGlobal.isPinTextItem(item.itemInfo.id) && !marietta.webcad.WebCADGlobal.isPinPanoramaItem(item.itemInfo.id)) item.itemInfo.z = 0;
            break;
        }
      }
      // 3D で動かしたとき（位置が来たとき）だけ、動かし終わりとして扱う。サイズだけの更新では扱わない
      if (x !== null || y !== null) {
        this.onItemsMoved();
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

      // 3D でサイズを変えた選択中アイテムは、2D のピッカーを新しいサイズで作り直す
      if (item === this.currentItem && (_widthmm !== null || _heightmm !== null)) this.currentItem = item;

      // 見積リスト更新
      marietta.webcad.WebCADGlobal.quotationItemList.createData();
    }
  }

  /**
   * アイテム削除
   * @param guid
   */
  delete2Ditem = (guid:string) => {
    const item:MonicaObject = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(guid);
    if (item) {
      item.deleteMe();
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }
  }

  /**
   * アイテム追加
   * @param id
   * @param x
   * @param y
   * @param z
   * @param rotation
   * @param floor
   * @param text
   * @returns
   */
  add2Ditem = (id:string, x:number, y:number, z:number, rotation:number, floor:number = null, text: string = '') => {
    const info = new marietta.webcad.collection.ItemInfoCollection();
    info.id = id;
    if (floor != null) {
      info.floor = floor;
    }
    info.guid = marietta.webcad.WebCADGlobal.getGuid();
    const item = marietta.webcad.WebCADGlobal.LIBRARY_ITEMSLIST.get(id);
    let width = 0;
    let height = 0;
    if (item) {
      width = Number(item.widthmm);
      height = Number(item.heightmm);
    }
    if (marietta.webcad.WebCADGlobal.isPinTextItem(info.id)) {
      if (text == null) {
        text = '';
      }
      info.text = text;
      const textSize = marietta.webcad.util.TextUtil.getTextSizeWh(text, marietta.webcad.WebCADGlobal.freeTextFontFamily, marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size);
      info.width = textSize.width;
      info.height = textSize.height;
      info.text_color = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_color;
      info.is_italic = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_italic;
      info.is_bold = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_bold;
      info.is_strike_through = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_strike_through;
      info.is_bold = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_bold;
      info.font_size = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size;
    } else {
      info.widthmm = width;
      info.heightmm = height;
    }
    if (x !== null) info.x = marietta.webcad.util.WebCADUtil.convertMMToPix(x);
    if (y !== null) info.y = marietta.webcad.util.WebCADUtil.convertMMToPix(y);
    info.z = Math.round(z * 100) / 100;
    info.rotation = rotation;
    const heightData = this.getFloorAndCeilingHeight();
    const isCelingItem = marietta.webcad.WebCADGlobal.ceilingItemCodeList.includes(info.id);
    const isWallItem = marietta.webcad.WebCADGlobal.doesItemSupportZPositioning(info.id);
    const fl = floor === 1 ? heightData.fl1 : (floor === 2 ? heightData.fl2 : heightData.fl3);
    const ceiling = floor === 1 ? heightData.cl1 : (floor === 2 ? heightData.cl2 : heightData.cl3);
    switch (true) {
      case (isCelingItem && isWallItem):
        info.is_ceiling_item = true;
        info.z = ceiling - info.z;
        break;
      case (isCelingItem && !isWallItem):
        info.is_ceiling_item = true;
        info.z = 0;
        break;
      case (!isCelingItem && isWallItem):
        info.z -= fl;
        break;
      case (marietta.webcad.WebCADGlobal.isHeightEditableItem(info.id)):
        info.z = this.toFloorItemZ(info.z, fl);
        break;
      default:
        if (!marietta.webcad.WebCADGlobal.isPinTextItem(info.id))info.z = 0;
        break;
    }
    if (info.id.substring(0, 3) === 'fur' || info.id.substring(0, 3) === 'equ' || info.id.substring(0, 3) === 'ext' || info.id.substring(0, 3) === 'fit') {
      const item = marietta.webcad.WebCADGlobal.LIBRARY_ITEMSLIST.get(info.id);
      if (item) info.text = marietta.webcad.WebCADGlobal.language === 'jp' ? item.name.substring(0, 10) : item.name_en.substring(0, 10);
    }

    const newItem = marietta.webcad.WebCADGlobal.itemManager.createItem(info);
    newItem.setParentRoom();
    // 見積リスト更新
    marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();
    return (newItem) ? newItem.itemInfo.guid : null;
  }

  /**
   * 床置きアイテムの3D高さ(mm)を FL 基準の z にする。床面の誤差で負にならないよう 0 で止める
   */
  private toFloorItemZ(worldZ: number, fl: number): number {
    return Math.max(0, worldZ - fl);
  }

  private canMaterialChanged(id: string): boolean {
    const index = ['fit01_01', 'fit01_02', 'fit01_03'].indexOf(id);
    if (index == -1) {
      console.log(`マテリアルの変更ができません　${id}`);
      return false;
    }
    return true;
  }

  /**
   * ポイント壁の２D戻しAPI
   * @param guid : string
   * @param side : number 0:内部 1: 外部
   * @param materialId :string
   */
  updateWallMaterial = (guid:string, side:number, materialId:string):void => {
    let itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.MonicaObject[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_BEAM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_COLUMN_NO) as marietta.webcad.item.MonicaObject[]);

    const point = itemList.flatMap((a) => a.itemInfo.dotList).find((dot) => dot.guid === guid);
    if (point) {
      if (side === 0) {
        point.material.inner = materialId;
      } else {
        point.material.outer = materialId;
      }
      return;
    }

    // 見つからない場合は、壁アイテムも検索
    itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTING_NO) as marietta.webcad.item.MonicaObject[];
    const point2 = itemList.find((item) => item.itemInfo.guid === guid);
    if (point2 && this.canMaterialChanged(point2.itemInfo.id)) {
      point2.itemInfo.material.wall = materialId;
    }
  }

  /**
   * ポイント壁の２D戻しAPI
   * @param guid : string
   * @param side : number 0:内部 1: 外部
   * @param info :MasterItemCollection
   */
  updateWallEndItem = (guid:string, side:number, info:MasterItemCollection):void => {
    let itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.MonicaObject[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_COLUMN_NO) as marietta.webcad.item.MonicaObject[]);

    const point = itemList.flatMap((a) => a.itemInfo.dotList).find((dot) => dot.guid === guid);
    if (point) {
      if (side === 0) {
        point.inner_end_item_info = info;
      } else {
        point.outer_end_item_info = info;
      }
      // 梁は保存時に保管場所を変える（親）
      return;
    }

    // 見つからない場合は、壁アイテムも検索
    itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTING_NO) as marietta.webcad.item.MonicaObject[];
    const point2 = itemList.find((item) => item.itemInfo.guid === guid);
    if (point2 && ( marietta.webcad.WebCADGlobal.isCapableOfHavingEndItemFitting( point2.itemInfo.id ) )) {
      point2.itemInfo.end_item_info = info;
    }
  }

  /**
   * guid による壁
   * @param guid : string
   *
   */
  getWallByGuid = (guid:string): marietta.webcad.collection.PointCollection => {
    let itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.MonicaObject[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_BEAM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_COLUMN_NO) as marietta.webcad.item.MonicaObject[]);

    return itemList.flatMap((a) => a.itemInfo.dotList).find((dot) => dot.guid === guid);
  }

  /**
   * guid による壁の親検出
   * @param guid : string
   *
   */
  getWallParentByGuid = (guid:string): marietta.webcad.item.MonicaObject => {
    let itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.MonicaObject[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_BEAM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_COLUMN_NO) as marietta.webcad.item.MonicaObject[]);

    for (let i:number = 0; i < itemList.length; i += 1) {
      for (let k:number = 0; k < itemList[i].itemInfo.dotList.length; k += 1) {
        if (itemList[i].itemInfo.dotList[k].guid === guid) {
          return itemList[i];
        }
      }
    }
    return null;
  }

  /**
   * ポイント壁のエンドアイテム取得
   * @param guid : string
   * @param side : number 0:内部 1: 外部
   */
  getWallEndItem = (guid:string, side:number):MasterItemCollection => {
    let itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.MonicaObject[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_WALL_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_BEAM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_COLUMN_NO) as marietta.webcad.item.MonicaObject[]);
    const point = itemList.flatMap((a) => a.itemInfo.dotList).find((dot) => dot.guid === guid);
    if (point) {
      if (side === 0) {
        return point.inner_end_item_info;
      }
      return point.outer_end_item_info;
    }

    // 見つからない場合は、壁アイテムも検索
    itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTING_NO) as marietta.webcad.item.MonicaObject[];
    const point2 = itemList.find((item) => item.itemInfo.guid === guid);
    if (point2 && (point2.itemInfo.id === 'fit01_01' || point2.itemInfo.id === 'fit01_02' || point2.itemInfo.id === 'fit01_03')) {
      return point2.itemInfo.end_item_info;
    }

    return null;
  }

  /**
   * 床の親取得
   * @param guid : string
   */
  getWallParentItem = (guid:string):MonicaObject => {
    let itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.MonicaObject[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_WALL_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_BEAM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_COLUMN_NO) as marietta.webcad.item.MonicaObject[]);

    let room: MonicaObject = null;
    for (let i: number = 0; i < itemList.length; i += 1) {
      for (let k: number = 0; k < itemList[i].itemInfo.dotList.length; k += 1) {
        if (itemList[i].itemInfo.dotList[k].guid === guid) {
          room = itemList[i];
          return room;
        }
      }
    }

    // 見つからない場合は、壁アイテムも検索
    itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTING_NO) as marietta.webcad.item.MonicaObject[];
    const point2 = itemList.find((item) => item.itemInfo.guid === guid);
    if (point2 && point2.itemInfo.id === 'fit01_01') {
      return point2;
    }
    return null;
  }

  /**
   * 床のマテリアルの２D戻しAPI
   * @param guid : string
   * @param materialId :string
   */
  updateFloorMaterial = (guid:string, materialId:string):void => {
    let itemList: marietta.webcad.item.Room[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.Room[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.Room[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.Room[]);
    const room = itemList.flatMap((a) => a.itemInfo).find((room) => room.guid === guid);
    room.material.floor = materialId;
  }

  /**
   * 床のエンドアイテムの設定
   * @param guid : string
   * @param info :MasterItemCollection
   */
  updateFloorEndItem = (guid:string, info:MasterItemCollection):void => {
    let itemList: marietta.webcad.item.Room[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.Room[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.Room[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.Room[]);
    const room = itemList.flatMap((a) => a.itemInfo).find((room) => room.guid === guid);
    room.floor_end_item_info = info;
  }

  /**
   * 床のエンドアイテム取得
   * @param guid : string
   */
  getFloorEndItem = (guid:string):MasterItemCollection => {
    let itemList: marietta.webcad.item.Room[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.Room[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.Room[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.Room[]);
    const room = itemList.flatMap((a) => a.itemInfo).find((room) => room.guid === guid);
    return room.floor_end_item_info;
  }

  /**
   * 床の親取得
   * @param guid : string
   */
  getFloorParentItem = (guid:string):MonicaObject => {
    let itemList: marietta.webcad.item.Room[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.Room[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.Room[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.Room[]);
    let room: MonicaObject = null;
    for (let i: number = 0; i < itemList.length; i += 1) {
      if (itemList[i].itemInfo.guid === guid) {
        room = itemList[i];
        break;
      }
    }
    return room;
  }
  /**
   * 天井のマテリアルの２D戻し
   * @param guid : string
   * @param materialId :string
   */
  updateCeilingMaterial = (guid:string, materialId:string):void => {
    let itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.MonicaObject[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_BEAM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_COLUMN_NO) as marietta.webcad.item.MonicaObject[]);
    const room = itemList.flatMap((a) => a.itemInfo).find((room) => room.guid === guid);

    room.material.ceiling = materialId;
  }

  /**
   * 天井のエンドアイテム設定
   * @param guid : string
   * @param info :MasterItemCollection
   */
  updateCeilingEndItem = (guid:string, info:MasterItemCollection):void => {
    let itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.MonicaObject[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.MonicaObject[]);
    const room = itemList.flatMap((a) => a.itemInfo).find((room) => room.guid === guid);
    if (room) {
      room.ceiling_end_item_info = info;
      return;
    }
    // 見つからない場合は、壁アイテムも検索
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_BEAM_NO) as marietta.webcad.item.MonicaObject[]);
    const beam = itemList.flatMap((a) => a.itemInfo).find((beam) => beam.guid === guid);
    if (beam) {
      beam.end_item_info = info;
    }
  }

  /**
   * 天井のエンドアイテム取得
   * @param guid : string
   */
  getCeilingEndItem = (guid:string):MasterItemCollection => {
    let itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.MonicaObject[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.MonicaObject[]);
    const room = itemList.flatMap((a) => a.itemInfo).find((room) => room.guid === guid);
    if (room) return room.ceiling_end_item_info;
    // 梁は updateCeilingEndItem で end_item_info に書き込むため、同じ項目から読む
    const beamList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_BEAM_NO) as marietta.webcad.item.MonicaObject[];
    const beam = beamList.flatMap((a) => a.itemInfo).find((beam) => beam.guid === guid);
    if (beam) return beam.end_item_info;
    const columnList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_COLUMN_NO) as marietta.webcad.item.MonicaObject[];
    const column = columnList.flatMap((a) => a.itemInfo).find((column) => column.guid === guid);
    return column.ceiling_end_item_info;
  }

  /**
   * 天井のエンドアイテム取得
   * @param guid : string
   */
  getCeilingParentItem = (guid:string):MonicaObject => {
    let itemList: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.MonicaObject[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_BEAM_NO) as marietta.webcad.item.MonicaObject[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_COLUMN_NO) as marietta.webcad.item.MonicaObject[]);
    let room:MonicaObject = null;
    for (let i:number = 0; i < itemList.length; i += 1) {
      if (itemList[i].itemInfo.guid === guid) {
        room = itemList[i];
        break;
      }
    }

    return room;
  }

  /**
   *左下原点を左上原点に変換（mm）
   * @param x
   * @param y
   */
  changePoint(x: number, y: number):{x: number, y: number} {
    const retX: number = x;
    const MM_H:number = marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H);
    const twoDim:number = MM_H - y;
    return { x: retX, y: twoDim };
  }

  /**
   * Get floor level and ceiling level of each floor
   * @returns
   */
  getFloorAndCeilingHeight = () => {
    const height = marietta.webcad.WebCADGlobal.autoMain.GetDesignHigh();
    const a = Number(height['A']);
    const a2 = Number(height['A2']);
    const fl1 = (Number(height['D']));
    const fl2 = a + (Number(height['B2']));
    const fl3 = (a + Number(height['B'])) + (Number(height['C2']));

    const cl1 = (Number(height['D']) - a2) + (Number(height['A1']) + a2);
    const cl2 = fl2 + Number(height['B1']);
    const cl3 = fl3 + Number(height['C1']);

    return {
      fl1, fl2, fl3, cl1, cl2, cl3,
    };
  }

  /**
   * Get floor level and ceiling level of particular floor
   * @param floor
   * @returns
   */
  getFloorAndCeilingHeightOfFloor = (floor: number = null) => {
    const floorData = this.getFloorAndCeilingHeight();
    if (floor == null) {
      floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    }
    const floorInfo = {
      floorHeight: 0,
      ceilingHeight: 0,
    };
    switch (floor) {
      case 1:
        floorInfo.floorHeight = floorData.fl1;
        floorInfo.ceilingHeight = floorData.cl1;
        break;
      case 2:
        floorInfo.floorHeight = floorData.fl2;
        floorInfo.ceilingHeight = floorData.cl2;
        break;
      case 3:
        floorInfo.floorHeight = floorData.fl3;
        floorInfo.ceilingHeight = floorData.cl3;
        break;
      default:
        floorInfo.floorHeight = floorData.fl1;
        floorInfo.ceilingHeight = floorData.cl1;
        break;
    }
    return floorInfo;
  }

  /**
   * アイテムの一括グレード設定
   */
  setAllItemsToGrade(resolve:any = null, force:boolean = false):void {
    // 住宅設備、家具アイテム
    let itemList:any[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTING_NO);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTINGDOWN1_NO));
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_EQUIPMENT_NO));

    for (let i:number = 0; i < itemList.length; i += 1) {
      // https://mari.backlog.jp/view/STARTS_LIDAR-1948#comment-1545384776 エンドアイテム上書きで問題ない&エンドアイテムない場合はリセット
      // 既に設定されていれば、実施しない
      // if (!force) {
      //   if (itemList[i].itemInfo.end_item_info) continue;
      //   if (itemList[i].itemInfo.white_item_info) continue;
      // }

      const endItemInfo:MasterItemCollection = marietta.webcad.WebCADGlobal.webcad2Dmanager.grade.getItemInfoForSymbol(itemList[i].itemInfo.id);
      if (endItemInfo) {
        itemList[i].setToEndItem(endItemInfo);
      } else {
        // 管理サイトで未設定（マスタの list 内になし）の場合は end_item_info を null にリセットし、
        // 3D モデルもホワイトモデルへ戻す（idthreed を空にすると base ID の .glb がロードされる）
        itemList[i].itemInfo.end_item_info = null;
        itemList[i].itemInfo.idthreed = '';
      }
    }

    // 壁
    const rooms:MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO);
    for (let i:number = 0; i < rooms.length; i += 1) {
      this.setRoomToGrade(rooms[i] as Room);
    }

    // 商品が外れた UB を天井高さに戻す（この操作は履歴を積まない）
    marietta.webcad.WebCADGlobal.webcad2Dmanager.commitWithoutHistory();

    // カレント
    marietta.webcad.WebCADGlobal.itemManager.currentItem = null;

    if (resolve) resolve();
  }

  /**
   * 部屋が天井・床・壁の仕上情報を持っているか（新規の部屋は全て null）
   * setRoomToGrade が上書きする範囲と対応させ、保存済みの仕上をマスタ値で潰さないための判定
   */
  private hasRoomFinish(room:Room):boolean {
    const info:marietta.webcad.collection.ItemInfoCollection = room.itemInfo;
    if (info.ceiling_end_item_info || info.floor_end_item_info) return true;
    if (info.ceiling_white_item_info || info.floor_white_item_info) return true;
    if (info.material && (info.material.ceiling || info.material.floor)) return true;
    return (info.dotList ?? []).some((dot) => !!dot.inner_end_item_info
      || !!dot.inner_white_item_info
      || !!(dot.material && dot.material.inner));
  }

  /**
   * アイテムの一括グレード設定
   * https://mari.backlog.jp/view/STARTS_LIDAR-1948#comment-1545384776 エンドアイテム上書きで問題ない&エンドアイテムない場合はリセット
   */
  setRoomToGrade(room:Room, resolve:any = null):void {
    const grade:GradeMasterCollection = marietta.webcad.WebCADGlobal.webcad2Dmanager.grade;
    if (!grade) {
      if (resolve) resolve();
      return;
    }

    // 壁
    const wallEndItemInfo:MasterItemCollection = grade.getItemInfoForSymbol('wallpaper');
    for (let k:number = 0; k < room.itemInfo.dotList.length; k += 1) {
      room.itemInfo.dotList[k].inner_end_item_info = wallEndItemInfo ?? null;
      // マスタで未設定の場合も 3D マテリアルを null でクリア（天井・床と挙動を揃える）
      marietta.webcad.WebCADGlobal.itemManager.updateWallMaterial(
        room.itemInfo.dotList[k].guid,
        0,
        wallEndItemInfo ? wallEndItemInfo.symbol_3d_code : null
      );
    }
    room.itemInfo.ceiling_end_item_info = wallEndItemInfo ?? null;
    room.itemInfo.material.ceiling = wallEndItemInfo ? wallEndItemInfo.symbol_3d_code : null;

    // 玄関、バルコニー、ポーチなど、床が特殊なところはやらない。
    if (!marietta.webcad.WebCADGlobal.isRoomForFloorEndItem(room)) return;

    // 床
    const endItemInfo:MasterItemCollection = marietta.webcad.WebCADGlobal.webcad2Dmanager.grade.getItemInfoForSymbol('flooring');
    room.itemInfo.floor_end_item_info = endItemInfo ?? null;
    room.itemInfo.material.floor = endItemInfo ? endItemInfo.symbol_3d_code : null;

    if (resolve) resolve();
  }

  /**
   * アイテムの一括グレード設定
   * https://mari.backlog.jp/view/STARTS_LIDAR-1948#comment-1545384776 エンドアイテム上書きで問題ない&エンドアイテムない場合はリセット
   */
  setItemToGrade(item:MonicaObject, grade:GradeMasterCollection):void {
    const endItemInfo:MasterItemCollection = grade.getItemInfoForSymbol(item.itemInfo.id);
    // 適用
    item.setToEndItem(endItemInfo ?? null);
  }
}
